import React, { useEffect, useRef, useState } from 'react'

// Simple intersection-based reveal wrapper
// Props: as (tag), className, delay (ms), once (bool)
const ScrollReveal = ({ as: Tag = 'div', className = '', delay = 0, once = true, children }) => {
  const ref = useRef(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => setVisible(true), delay)
            if (once) observer.unobserve(el)
          } else if (!once) {
            setVisible(false)
          }
        })
      },
      { threshold: 0.15 }
    )

    observer.observe(el)
    return () => observer.disconnect()
  }, [delay, once])

  return (
    <Tag ref={ref} className={`sr ${visible ? 'sr-visible' : ''} ${className}`.trim()}>{children}</Tag>
  )
}

export default ScrollReveal

